import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';
import { MocksHelper } from './mocks/MocksHelper';
import AhorrosMockService from './mocks/AhorrosMockService';

// eslint-disable-next-line react-hooks/rules-of-hooks
const mocked = MocksHelper.useMocks();
const AhorrosService = {
  retrieveAhorrosInfo: (data: object) =>
    trackPromise(
      api.post(
        `/rest/ahorro/${i18next.language}/get/info`,
        JSON.stringify(data),
      ),
    ),
  retrieveAhorrosTicketTotalInfo: () =>
    trackPromise(
      api.post(`/rest/ahorro/${i18next.language}/get/ticket/total/info`),
    ),
  retrieveAhorrosTableInfo: (data: object) =>
    trackPromise(
      api.post(
        `/rest/ahorro/${i18next.language}/get/ticket/total/info/table`,
        JSON.stringify(data),
      ),
    ),
};
export default mocked ? AhorrosMockService : AhorrosService;
